import {scrollToSmooth, getWindow } from '../utils/dom-utils';
import getParameterByName from '../utils/url';
import {onPath} from '../utils/path';

onPath(['/global-accessibility-awareness-day/*', '/global-accessibility-awareness-day'], () => {
  const win = getWindow();
  win.addEventListener('load', () => {
    var scrollToTarget = getParameterByName('scroll-to');
    scrollToSmooth(scrollToTarget);
  });

});